// extracted by mini-css-extract-plugin
export default {"listItem":"MenuEntry_listItem__mtyXE"};